import JSON5 from 'json5';

import { CellValue, StructuredParseResult } from '../types';

export function parseStructured(value: CellValue): StructuredParseResult {
  if (value !== null && typeof value === 'object') {
    return { ok: true, data: value };
  }

  if (typeof value === 'string') {
    try {
      return { ok: true, data: JSON.parse(value) };
    } catch {
      try {
        return { ok: true, data: JSON5.parse(value) };
      } catch {
        return { ok: false, raw: value };
      }
    }
  }

  return { ok: false, raw: String(value) };
}
